<template>
   <div id="app">
      <router-view  v-on:footer="footer"/>
      <app-footer v-if="footer_show"></app-footer>
   </div>
</template>

<script>
import Footer from '@/components/Footer'
export default {
	name: 'App',
  data(){
    return {
      footer_show:true,
    }
  },
  components: {
    'app-footer':Footer,
  },
  created () {
   // this.$router.push({path:'/index'}); // 页面加载时跳转
  },
  methods:{
    //是否显示底部
    footer:function (bool) {
      this.footer_show = bool;
    }
  }
}
</script>

<style>
*{
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  list-style: none;
}


.active{
  height: 28px !important;
  color: #fff !important;
  background-color: #2b73cc !important;
  text-align: center !important;
  line-height: 28px !important;
}
.m_toast-pc-wrapper{
  top: 100px !important;
}
#app {
  /* min-width: 15rem; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue